import React, { useEffect, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from "./core/reportWebVitals";
import AppAuthProvider from "./core/contexts/AppAuthProvider";
import AppLoader from "./components/AppLoader/AppLoader";
import "./assets/style/index.scss";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Login from "./pages/Login/Login";

// import Events from './pages/Events/Events';

// import HeroSection from './pages/LandingPage/components/HeroSection/HeroSection';
// import Layout from './components/Layout/Layout';
// import RecentEvents from './pages/LandingPage/components/RecentEvents/RecentEvents';
import LandingPage from "./pages/LandingPage/LandingPage";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import Register from "./pages/Register/Register";
import UseLogout from "./core/hooks/UseLogout";
import Page403 from "./pages/403/Page403";
import Page404 from "./pages/403/Page403";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

import ReviewTraining from "./pages/ReviewTraining/ReviewTraining";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/Auth/logic/authConfig";
import TrainingEvalReport from "./pages/TrainingEvalReport/TrainingEvalReport";
// import TrainingRequest from "./pages/TrainingRequest/TrainingRequest";

// import Attendance from "./pages/Attendence/Attendance";
import AttendenceReport from "./pages/Attendence/AttendenceReport";
import AdminSpace from "./pages/AdminSpace/AdminSpace.jsx";
import ValidatingAttendancesByManager from "./pages/ValidatingAttendancesByManager/ValidatingAttendancesByManager";
import Attendance from "./pages/Attendance/Attendance";

import ValidatingAttendancesByTrainer from "./pages/ValidatingAttendancesByTrainer/ValidatingAttendancesByTrainer";
import TechnicalObjectives from "./pages/TechnicalObjectives/TechnicalObjectives";
import BehavioralObjectives from "./pages/BehavioralObjectives/BehavioralObjectives";
import TrainingDetails from "./pages/TrainingDetails/TrainingDetails";
import QuizPreview from "./pages/QuizManagement/QuizPreview/QuizPreview.jsx";
import ProgressTrackerInfo from "./pages/Profile/components/ProgressTracker/ProgressTrackerInfo/ProgressTrackerInfo.jsx";
import ProjectManagerSpace from "./pages/ProjectManagerSpace/ProjectManagerSpace.jsx";
import TrainingManagerSpace from "./pages/CenterManagerSpace/TrainingManagerSpace.jsx";
import AppHeader from "./components/AppHeader/AppHeader.jsx";
import ContactUs from "./pages/LandingPage/components/ContactUs/ContactUs.jsx";
import DivisionManagerSpace from "./pages/Departments/DivisionManagerSpace.jsx";
import TrainerProfile from "./pages/Profile/TrainerProfile.jsx";
// import EventRequest from "./pages/EventRequest/EventRequest.jsx";
import CourseSkillsAssignment from "./pages/Courses/components/CourseSkillsAssignment/CourseSkillsAssignment.jsx";
import FormViewer from "./pages/Departments/components/AnnualEvaluation/components/EvaluationFormHeader/components/FormViewer.jsx";

const Courses = React.lazy(() => import("./pages/Courses/Courses"));
const Events = React.lazy(() => import("./pages/Events/Events"));
const EventDetails = React.lazy(() =>
  import("./pages/EventDetails/EventDetails")
);
const CourseDetails = React.lazy(() =>
  import("./pages/CourseDetails/CourseDetails")
);
const Profile = React.lazy(() => import("./pages/Profile/Profile"));
const LearningPaths = React.lazy(() =>
  import("./pages/LearningPaths/LearningPaths")
);
const LearningPathCreation = React.lazy(() =>
  import("./pages/LearningPathCreation/LearningPathCreation")
);
const LearningPathUpdate = React.lazy(() =>
  import("./pages/LearningPathUpdate/LearningPathUpdate")
);
const CreateQuiz = React.lazy(() =>
  import("./pages/QuizManagement/CreateQuiz/CreateQuiz")
);
const UpdateQuiz = React.lazy(() =>
  import("./pages/QuizManagement/UpdateQuiz/UpdateQuiz.jsx")
);
const QuizTest = React.lazy(() =>
  import("./pages/QuizManagement/QuizTest/QuizTest.jsx")
);

const MainApp = () => {
  //hide init loader when html document is fully loaded
  useEffect(() => {
    const hideAppLoader = () =>
      document.getElementById("avxInitLoader").classList.add("hiddenLoader");
    if (document.readyState === "complete") hideAppLoader();
    else {
      window.addEventListener("load", hideAppLoader);
      return () => window.removeEventListener("load", hideAppLoader);
    }
  }, []);

  return (
    <>
      {/* <AppHeader /> */}
      <Navbar />
      <Routes>
        {/* Private Routes -> Require Auth */}
        {/* <Route path="/" element={ <ProtectedRoute /> } >
          <Route index element={ <Suspense fallback={<AppLoader />}><Home /></Suspense> } />
          <Route path="civilis" element={ <Suspense fallback={<AppLoader />}><Civilis /></Suspense> } /> */}

        {/* Private Routes With Restricted Access -> Require Permission */}
        {/* <Route path="arcanus" element={ <ProtectedRoute permission="access-arcanus" /> } >
            <Route index element={ <Suspense fallback={<AppLoader />}><Arcanus /></Suspense> } />
          </Route>
        </Route> */}

        {/* EXAMPLE ROUTE WITH PERMISSION */}
        {/* <Route path="permissionRoute" element={ <ProtectedRoute permission={["Admin", "Trainee"]} /> } >
            <Route index element={ <Suspense fallback={<AppLoader />}><Courses /></Suspense> } />
          </Route> */}
        <Route path="/" element={<ProtectedRoute />}>
          <Route
            path="/profile/:id"
            element={
              <Suspense fallback={<AppLoader />}>
                <Profile />
              </Suspense>
            }
          />
          <Route
            path="/profile/:id/training-details/:id"
            element={
              <Suspense fallback={<AppLoader />}>
                <ProgressTrackerInfo />
              </Suspense>
            }
          />

          {/* <Route path='/create-course' element={<Suspense fallback={<AppLoader />} ><CourseDetails editMode="Create" /></Suspense>} /> */}
          <Route
            path="create-course"
            element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
          >
            <Route
              index
              element={
                <Suspense fallback={<AppLoader />}>
                  <CourseDetails editMode="Create" />
                </Suspense>
              }
            />
          </Route>
        </Route>
        <Route
          index
          element={
            <Suspense fallback={<AppLoader />}>
              <LandingPage />
            </Suspense>
          }
        />
        <Route
          path="/edit-course/:id"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <CourseDetails editMode="Edit" />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/quiz/:id"
          element={
            <Suspense fallback={<AppLoader />}>
              <QuizTest />
            </Suspense>
          }
        />
        <Route
          path="/quizCreation"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <CreateQuiz />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/quizUpdate/:id"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <UpdateQuiz />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/quizPreview/:id"
          element={
            <Suspense fallback={<AppLoader />}>
              <QuizPreview />
            </Suspense>
          }
        />
        <Route
          path="/learningPaths"
          element={
            <Suspense fallback={<AppLoader />}>
              <LearningPaths />
            </Suspense>
          }
        />
        <Route
          path="/learningPathCreation"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <LearningPathCreation />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/edit-learningPath/:id"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <LearningPathUpdate />
              </Suspense>
            }
          />
        </Route>

        <Route
          path="/courses/:id"
          element={
            <Suspense fallback={<AppLoader />}>
              <CourseDetails />
            </Suspense>
          }
        />
        <Route
          path="/events/:id"
          element={
            <Suspense fallback={<AppLoader />}>
              <EventDetails />
            </Suspense>
          }
        />
        <Route
          path="/events"
          element={
            <Suspense fallback={<AppLoader />}>
              <Events />
            </Suspense>
          }
        />
        <Route
          path="/trainer-profile"
          element={
            <Suspense fallback={<AppLoader />}>
              <TrainerProfile />
            </Suspense>
          }
        />
        <Route
          path="/TrainingReport/:id"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <TrainingEvalReport />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/review/:trainingId/:userId"
          element={<ProtectedRoute permission={["Trainee"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <ReviewTraining />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/TrainingDetails/:id"
          element={
            <Suspense fallback={<AppLoader />}>
              <TrainingDetails />
            </Suspense>
          }
        />
        <Route
          path="/courses"
          element={
            <Suspense fallback={<AppLoader />}>
              <Courses />
            </Suspense>
          }
        />

        <Route
          path="/login"
          element={
            <Suspense fallback={<AppLoader />}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <Suspense fallback={<AppLoader />}>
              <Register />
            </Suspense>
          }
        />
        <Route
          path="/contact-us"
          element={
            <Suspense fallback={<AppLoader />}>
              <ContactUs />
            </Suspense>
          }
        />
        <Route path="/logout" element={<UseLogout />} />
        <Route path="/403" element={<Page403 />} />
        <Route path="*" element={<Page404 />} />

        <Route
          path="/profile"
          element={
            <Suspense fallback={<AppLoader />}>
              <Profile />
            </Suspense>
          }
        />

        <Route
          path="adminspace/:tab?"
          element={<ProtectedRoute permission={["Admin"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <AdminSpace />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="departments/:tab?"
          element={<ProtectedRoute permission={["DivisionManager"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <DivisionManagerSpace />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="projectManagerSpace/:tab?"
          element={<ProtectedRoute permission={["Project Manager"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <ProjectManagerSpace />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="trainingmanager/:tab?"
          element={<ProtectedRoute permission={["Editor"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <TrainingManagerSpace />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="trainingmanager/:tab?"
          element={<ProtectedRoute permission={["Editor"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <TrainingManagerSpace />
              </Suspense>
            }
          />
        </Route>
        {/* <Route path='/attendence' element={<Suspense fallback={<AppLoader />} ><Attendance /></Suspense>} /> */}
        <Route
          path="/attendenceReport/:id"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <AttendenceReport />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/validateAttendanceManager/:id"
          element={<ProtectedRoute permission={["Admin"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <ValidatingAttendancesByManager />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/technicalObjectives/:trainingId"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <TechnicalObjectives />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/behavioralObjectives/:trainingId"
          element={<ProtectedRoute permission={["Admin", "Trainer"]} />}
        >
          <Route
            index
            element={
              <Suspense fallback={<AppLoader />}>
                <BehavioralObjectives />
              </Suspense>
            }
          />
        </Route>

        <Route
          path="/courseSkillsAssignment"
          element={<CourseSkillsAssignment permission={["Admin"]} />}
        ></Route>
        <Route path="/forms/:formId/view" element={<FormViewer />} />

      </Routes>

      {/* <Footer /> */}
      {/* <AppFooter /> */}
    </>
  );
};
const queryClient = new QueryClient();
const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("mainApp"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/">
        <AppAuthProvider>
          <MsalProvider instance={msalInstance}>
            <MainApp />
          </MsalProvider>
        </AppAuthProvider>
      </BrowserRouter>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
